"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureAddSmallGeomsAsPoint = void 0;
var olExtent = require("ol/extent");
var Point_1 = require("ol/geom/Point");
var FeatureAddSmallGeomsAsPoint = /** @class */ (function () {
    function FeatureAddSmallGeomsAsPoint(scalingFactor) {
        if (scalingFactor === void 0) { scalingFactor = 4; }
        this.scalingFactor = scalingFactor;
        this.showAsPoint = function (exent, maxLen) {
            return Math.max(olExtent.getHeight(exent), olExtent.getWidth(exent)) < maxLen;
        };
    }
    FeatureAddSmallGeomsAsPoint.prototype.addFeature = function (vectorLayerSource, feature, resolution) {
        var ignoreTypes = ["point", "multipoint"];
        var geom = feature.getGeometry();
        //operate on all geoms except point
        if (ignoreTypes.indexOf(geom.getType().toLowerCase()) === -1) {
            var extent = geom.getExtent();
            var maxLen = resolution * this.scalingFactor;
            if (this.showAsPoint(extent, maxLen)) {
                //show as point                
                var p = new Point_1.default(olExtent.getCenter(extent));
                feature.setGeometry(p);
            }
        }
        vectorLayerSource.source.addFeature(feature);
    };
    return FeatureAddSmallGeomsAsPoint;
}());
exports.FeatureAddSmallGeomsAsPoint = FeatureAddSmallGeomsAsPoint;
//# sourceMappingURL=FeatureAddSmallGeomsAsPoint.js.map